import type { EnemyConfig } from '../../entities/EnemyConfig';

export const FOX_CONFIG: EnemyConfig = {
  id: 'fox',
  displayName: 'Лиса',
  maxHp: 2,
  speed: 110,
  movementBehavior: 'random_zigzag',
  movementParams: {
    minChangeIntervalMs: 800,
    maxChangeIntervalMs: 1200,
    minAngleDeltaDeg: 30,
    maxAngleDeltaDeg: 60,
    maxAngleFromForward: 70,
  },
  size: 27,
  color: 0xcc5a2a,
  scoreReward: 10,
};
